import {
	ActivatedRoute,
	NavigationCancel,
	NavigationEnd,
	NavigationStart,
	Router
} from '@angular/router';
import {
	AfterViewInit,
	Component,
	inject,
	OnInit,
	Renderer2
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoutePartsService } from './shared/services/route-parts.service';
import { ThemeService } from './shared/services/theme.service';
import { Title } from '@angular/platform-browser';

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.css"],
	standalone: true,
	imports: [RouterModule, NgxSpinnerModule]
})
export class AppComponent implements OnInit, AfterViewInit {
	title = inject(Title);
	private router = inject(Router);
	private activeRoute = inject(ActivatedRoute);
	private routePartsService = inject(RoutePartsService);
	private themeService = inject(ThemeService);
	private renderer = inject(Renderer2);
	private _spinner = inject(NgxSpinnerService);

	appTitle = "Protecta Security - Tarifario";
	pageTitle = "";

	ngOnInit() {
		this.changePageTitle();
	}

	ngAfterViewInit() {
		this.themeService.applyMatTheme(this.renderer);

		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this._spinner.show();
			} else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
				this._spinner.hide();
			}
		});
	}

	changePageTitle() {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(routeChange => {
			const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
			if (!routeParts.length) {
				return this.title.setTitle(this.appTitle);
			}
			// Extract title from parts;
			this.pageTitle = routeParts
				.reverse()
				.map(part => part.title)
				.reduce((partA, partI) => {
					return `${partA} > ${partI}`;
				});
			// this.pageTitle += ` | ${this.appTitle}`;
			this.title.setTitle(this.pageTitle);
		});
	}
}
